<template>
  <div class="merchant-nav">
    <div class="nav-tabs">
      <div v-for="tab in tabs" :key="tab.id" :class="['tab-item', { 'active': activeTab === tab.id }]"
           @click="activeTab = tab.id">
        {{ tab.label }}
      </div>
    </div>
  </div>
  <keep-alive>
    <div v-if="mainData.length!=0">
      <component :is="currentTabComponent" :mainData="mainData" :id="placeId" />
    </div>
    <div v-else>
      <component :is="currentTabComponent" :id="placeId" />
    </div>
  </keep-alive>
</template>
<script setup name="MerchantDetail">
import { ref, computed } from "vue";
import DateList from "@/views/DateList.vue";
import Evaluation from "@/views/Evaluation.vue";
import Complaint from "@/views/Complaint.vue";
import Comment from "@/views/Comment.vue";
import router from "@/router";
import axios from "axios";

document.title = "商户详情";
const activeTab = ref("dateList");
const tabs = ref([{
  id: "evaluation",
  label: "商户信息"
}, {
  id: "dateList",
  label: "检测信息"
}, {
  id: "comment",
  label: "评价"
}, {
  id: "complaint",
  label: "投诉"
}]);
const mainData = ref([]);
const currentTabComponent = computed(() => {
  switch (activeTab.value) {
    case "evaluation":
      if (mainData.length != 0) {
        Evaluation.component;
      }
      return Evaluation;
    case "dateList":
      if (mainData.length != 0) {
        DateList.component;
      }
      return DateList;
    case "comment":
      return Comment;
    case "complaint":
      if (placeId.length != 0) {
        Complaint.component;
      }
      return Complaint;
    default:
      return Evaluation;
  }
});
const VUE_APP_API_URL = process.env.VUE_APP_API_URL;
const placeId = router.currentRoute.value.params.placeId;
if (/[a-zA-Z\u4e00-\u9fa5]/.test(placeId)) {
  axios.get(`${VUE_APP_API_URL}/open/selectSampleByLicenseNumber/placeName/${placeId}`)
    .then((response) => {
      if (response.data.data.list.length != 0) {
        mainData.value = response.data.data.list;
      }
    });
} else if (/^\d+$/.test(placeId)) {
  axios.get(`${VUE_APP_API_URL}/open/selectSampleByLicenseNumber/${placeId}`)
    .then((response) => {
      if (response.data.data.list.length != 0) {
        mainData.value = response.data.data.list;
      }
    });
}
</script>
<style scoped>
.merchant-nav {
  width: 100%;
}

.nav-tabs {
  display: flex;
  border-bottom: 1px solid #eee;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-item.active {
  color: #1890ff;
  font-weight: bold;
  border-bottom: 2px solid #1890ff;
}

.tab-item:hover {
  background-color: #f5f5f5;
}

.search-input input {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  outline: none;
}

.search-input button {
  padding: 6px 12px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}
</style>
